export const validateSteps = (formData, licenceRequired) => {
  const missing = {};

  // Dynamische Berechnung aus Step 2
  const bedroomCount =
    formData.rooms?.filter((r) => Number(r.room_type_id) === 1).length || 0;

  const bathroomCount =
    formData.rooms?.filter((r) => Number(r.room_type_id) === 2).length || 0;

  // STEP 1 – Grunddaten
  const step1Missing = [];
  if (!formData.name) step1Missing.push("name");
  if (!formData.object_type) step1Missing.push("object_type");
  if (!formData.street) step1Missing.push("street");
  if (!formData.house_number) step1Missing.push("house_number");
  if (!formData.postal_code) step1Missing.push("postal_code");
  if (!formData.city) step1Missing.push("city");
  if (!formData.country_id) step1Missing.push("country_id");
  if (formData.country_has_regions && !formData.region) step1Missing.push("region");

  if (licenceRequired && !formData.licence_number) {
    step1Missing.push("licence_number");
  }

  if (step1Missing.length > 0) missing[1] = step1Missing;


  // STEP 4 – Kontakt & Belegung
  const step4Missing = [];
  if (!formData.num_peoples) step4Missing.push("num_peoples");

  if (
    formData.max_pets === "" ||
    formData.max_pets === undefined ||
    formData.max_pets === null
  ) {
    step4Missing.push("max_pets");
  }

  // ❗ Schlafzimmer & Badezimmer NICHT mehr aus Step 4, sondern aus Step 2
 
  if (!formData.min_stay) step4Missing.push("min_stay");
  if (!formData.arrival_days?.length) step4Missing.push("arrival_days");
  if (!formData.check_in) step4Missing.push("check_in");
  if (!formData.check_out) step4Missing.push("check_out");

  if (!formData.contact_method || formData.contact_method === "none") {
    step4Missing.push("contact_method");
  }

  if (
    (formData.contact_method === "website" || formData.contact_method === "both") &&
    !formData.website_url
  ) {
    step4Missing.push("website_url");
  }

  if (
    (formData.contact_method === "email" || formData.contact_method === "both") &&
    !formData.contact_email
  ) {
    step4Missing.push("contact_email");
  }

  if (step4Missing.length > 0) missing[4] = step4Missing;


  // STEP 5 – Beschreibung
  const step5Missing = [];
  if (!formData.activity_nearby) step5Missing.push("activity_nearby");
  if (!formData.description) step5Missing.push("description");
  if (step5Missing.length > 0) missing[5] = step5Missing;


  // STEP 6 – Bilder
  const step6Missing = [];
  if (!formData.title_image) step6Missing.push("title_image");
  if (!formData.additional_images?.length) step6Missing.push("additional_images");
  if (step6Missing.length > 0) missing[6] = step6Missing;


// STEP 7 – Abo
let step7Missing = null;

if (!formData.subscription_plan) {
  step7Missing = ["subscription_plan"];
}

missing[7] = step7Missing;



  // Step Status
  const stepStatus = {
    1: !missing[1],
    2: true,
    3: true,
    4: !missing[4],
    5: !missing[5],
    6: !missing[6],
    7: !missing[7]
  };

  return { missing, stepStatus };
};
